import React, { useState } from "react";
import { useAuth, useNavigation } from "react-uicomp";
import { CSSTransition } from "react-transition-group";
import {
  useScroll,
  useAnimatedValue,
  AnimatedBlock,
  interpolate,
  useMeasure,
} from "react-ui-animate";
import {
  HiMenu,
  FaCartPlus,
  FaSearch,
  FaUserCircle,
  IoMdMenu,
  AiOutlineClose,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/all";

import { HeaderDropdown, HeaderDropdownMobile } from "./components";

import NepalSarkarLogo from "../../../assets/icons/nepalsarkar.png";
import NarcLogo from "../../../assets/icons/narc.png";
import NepalFlag from "../../../assets/icons/nepal_flag.gif";

const Header = () => {
  const { language } = useAuth();
  const { navigation } = useNavigation();
  const { routes, navigate } = navigation;
  const [headerTop, setHeaderTop] = useState(0);
  const [navInProp, setNavInProp] = useState(false);
  const [allFabrics, setAllFabrics] = useState(false);

  const toggleMenu = () => {
    setNavInProp(!navInProp);
  };

  const handleOutsideClick = (e) => {
    if (e.currentTarget === e.target) {
      setNavInProp(false);
    }
  };

  const allFabricHandler = (e) => {
    e.stopPropagation();
    setAllFabrics(!allFabrics);
  };

  const bind = useMeasure(({ top }) => {
    setHeaderTop(top);
  });

  const mainRoutes = Object.keys(routes)
    .filter((route) => routes[route].props === null)
    .map((route) => routes[route]);

  const sY = useAnimatedValue(0, { immediate: true });

  useScroll(({ scrollY }) => {
    sY.value = scrollY;
  });

  return (
    <AnimatedBlock
      style={{
        top: interpolate(sY.value, [0, headerTop], [0, -1 * headerTop], {
          extrapolate: "clamp",
        }),
      }}
      className="header-container">
      <div className="header">
        <div className="header-info">
          <span className="header-info-item">
            <span className="header-info-item-title">Phone:</span>
            <span className="header-info-item-value">
              {language.key.telephone}
            </span>
          </span>

          <span style={{ display: "inline-block", width: 20 }} />

          <span className="header-info-item">
            <span className="header-info-item-title">Email:</span>
            <span className="header-info-item-value">arspakh@gmail.com</span>
          </span>
        </div>

        <div className="header-top">
          <div className="header-top-image" onClick={() => navigate("/")}>
            <img src={NepalSarkarLogo} alt="Nepal Sarkar" />
          </div>

          <div className="header-top-middle">
            <div className="title nep" onClick={() => navigate("/")}>
              <p className="subtext">
                नेपाल&nbsp;कृषि&nbsp;अनुसन्धान&nbsp;परिषद्
              </p>
              <p>कृषि&nbsp;अनुसन्धान&nbsp;केन्द्र&nbsp;पाख्रिबास</p>
            </div>
            <div className="title" onClick={() => navigate("/")}>
              <p className="subtext">
                Nepal&nbsp;Agricultural&nbsp;Research&nbsp;Council
              </p>
              <p>Agricultural&nbsp;Research&nbsp;Station&nbsp;Pakhribas</p>
            </div>
          </div>

          <div className="header-top-images" onClick={() => navigate("/")}>
            <div className="header-img">
              <img src={NarcLogo} alt="NARC Logo" />
            </div>

            <div className="header-img">
              <img src={NepalFlag} alt="Nepal Flag" />
            </div>
          </div>
        </div>

        <div className="header-navigation-wrapper" {...bind()}>
          <ul className="header-navigation">
            {mainRoutes.length > 0
              ? mainRoutes.map(({ path, name }, i) => {
                  return <HeaderDropdown key={i} {...{ path, name }} />;
                })
              : null}
          </ul>
          <ul className="header-navigation mobile">
            <HiMenu onClick={toggleMenu} color="#FFF" size={40} />
          </ul>
        </div>
      </div>

      <div className="header-nav-mobile">
        <CSSTransition
          in={navInProp}
          timeout={200}
          classNames="nav-anims"
          unmountOnExit>
          <div className="sidebar-container" onClick={handleOutsideClick}>
            <div className="sidebar">
              <div className="sidebar-top">
                <div className="sidebar-top-title">
                  Agricultural Research Station Pakhribas
                </div>

                <div className="sidebar-top-close" onClick={toggleMenu}>
                  <AiOutlineClose />
                </div>
              </div>
              <ul className="sidebar-list" onClick={() => setNavInProp(false)}>
                {mainRoutes.length > 0
                  ? mainRoutes.map(({ path, name }, i) => {
                      return (
                        <HeaderDropdownMobile key={i} {...{ path, name }} />
                      );
                    })
                  : null}
              </ul>
              <div style={{ height: 100 }} />
            </div>
          </div>
        </CSSTransition>
      </div>
    </AnimatedBlock>
  );
};

export default Header;
